// This file is auto-generated by @hey-api/openapi-ts

export type BanStatus = 'Warning' | 'Banned';

export type Beast = {
    specieStageId: number;
    experience: number;
    totalExperience: number;
    level: number;
    happinessSnapshot: HappinessSnapshot;
    isLucky: boolean;
    equippedHatId?: string | null;
    reincarnations: number;
    readonly upgradesEarnMultiplier: number;
};

export type BeastDto = {
    id: string;
    specieStageId: number;
    experience: number;
    totalExperience: number;
    level: number;
    happinessSnapshot: HappinessSnapshot;
    isLucky: boolean;
    equippedHatId?: string | null;
    reincarnations: number;
};

export type BfDto = {
    x: number;
    y: number;
};

export type BuyItemRequest = {
    itemId: string;
};

export type BuyUpgradeParams = {
    upgradeId: string;
};

export type CoinShopItemListing = {
    itemId: string;
    coinCost: number;
    name: string;
    inStock: boolean;
};

export type CoinsDebugValues = {
    snapshot: CoinsSnapshot;
    balance: number;
    earningRate: number;
    beastEarnRate: number;
    upgradesEarnRate: number;
    earnStopsAt: Date;
};

export type CoinsSnapshot = {
    value: number;
    updatedAt: Date;
};

export type ConnectedSocials = {
    twitter: boolean;
    discord: boolean;
    zephyrus: boolean;
};

export type CreateQuestDto = {
    name: string;
    type: string;
    reward: number;
    startsAt: Date;
    endsAt?: Date | null;
    postId?: string | null;
    account?: string | null;
    serverId?: string | null;
    joinUrl?: string | null;
    channelUsername?: string | null;
    channelId?: string | null;
    contentId?: string | null;
    contentType?: string | null;
    url?: string | null;
    iconId?: string | null;
};

export type CreateRewardCodeDto = {
    reward: RewardType;
    rewardQuantity: number;
    endsAt: Date;
};

export type DailyStreakState = {
    currentStreak: number;
    lastClaimDate: Date;
    isTodayClaimed: boolean;
    isDebugMode: boolean;
};

export type DebugAddCoinsRequest = {
    amount: number;
};

export type DebugAddShardsRequest = {
    amount: number;
};

export type DebugFakePurchaseItemRequest = {
    listingId: string;
};

export type DebugValues = {
    playerDebugValues: PlayerDebugValues;
};

export type EffectType = 'UnlimitedEnergyEffect';

export type EnergyBall = {
    id: string;
    maxHealth: number;
    currentHealth: number;
    owner: string;
    readonly isDestroyed: boolean;
};

export type EnergySnapshot = {
    value: number;
    updatedAt: Date;
};

export type EquipItemRequest = {
    itemId: string;
};

export type GetRaffleTicketsResponse = {
    count: number;
};

export type HappinessSnapshot = {
    value: number;
    updatedAt: Date;
};

export type ICoinsShopGrain = {
    [key: string]: unknown;
};

export type InitiatePurchaseResponse = {
    invoiceLink: string;
};

export type InventoryItem = {
    itemId: string;
    quantity: number;
};

export type MiningAndFeedingRequest = {
    mineAmount: number;
    feedAmount: number;
};

export type OnboardingState = {
    currentStep: string;
    referralCode?: string | null;
    starterSelected: StarterOption;
    isCompleted: boolean;
    beastIsLucky: boolean;
};

export type Player = {
    version: number;
    id: string;
    username: string;
    shards: number;
    energySnapshot: EnergySnapshot;
    coinsSnapshot: CoinsSnapshot;
    beasts: Array<Beast>;
    referralCode: string;
    referredBy?: string | null;
    createdAt: Date;
    onboardingCompleted: boolean;
    upgrades: Array<PlayerUpgrade>;
    wallet: WalletPlayer;
    telegramUsername?: string | null;
    telegram: PlayerTelegram;
    signUpCode?: string | null;
    statusEffects: StatusEffects;
    beast: Beast;
};

export type PlayerBannedState = {
    userId: string;
    reason: string;
    status: BanStatus;
    bannedAt?: Date | null;
};

export type PlayerDebugValues = {
    coins: CoinsDebugValues;
};

export type PlayerPaginatedResponse = {
    items: Array<Player>;
    page: number;
    totalCount: number;
    hasNextPage: boolean;
};

export type PlayerQuestDto = {
    quest: Quest;
    status: PlayerQuestStatus;
};

export type PlayerQuestStatus = 'Active' | 'Completed' | 'Verifiable';

export type PlayerShopListing = {
    id: string;
    name: string;
    description: string;
    starsCost: number;
    locked: boolean;
    isPurchased: boolean;
    itemType: string;
};

export type PlayerStateDto = {
    energySnapshot: EnergySnapshot;
    coinsSnapshot: CoinsSnapshot;
    shards: number;
    upgrades: Array<PlayerUpgrade>;
    upgradesPerRate: number;
    coinsEarningRate: number;
    coinsEarningEndsAt: Date;
    beast: BeastDto;
    createdAt: Date;
    statusEffects: Array<StatusEffect>;
};

export type PlayerTelegram = {
    id: number;
    username: string;
};

export type PlayerUpgrade = {
    upgradeId: string;
    level: number;
};

export type PurchasableUpgrade = {
    name: string;
    description: string;
    category: string;
    upgradeId: string;
    level: number;
    cost: number;
    earnIncrement: number;
    canBePurchased: boolean;
    currentEarnAmount: number;
};

export type Quest = {
    id: string;
    name: string;
    reward: number;
    startsAt: Date;
    endsAt?: Date | null;
    createdAt: Date;
};

export type QuestVerificationResult = {
    isCompleted: boolean;
    failureReason?: string | null;
};

export type RaffleReward = 'EnergyBall' | 'Shards' | 'BronzeTreasureEgg' | 'SilverTreasureEgg' | 'GoldenTreasureEgg' | 'Kuro100' | 'LuckySerum' | 'SilverTicket' | 'Kuro500' | 'Kuro50K' | 'Kuro50' | 'EnergyDrink';

export type RefereeDto = {
    username: string;
    level: number;
};

export type ReferralCodeResponse = {
    referralCode: string;
};

export type ReferralsManagerState = {
    totalReferrals: number;
    referralCode: string;
    ownerId: string;
    luckySerumGained: boolean;
};

export type RewardCode = {
    id: string;
    reward: RewardType;
    rewardQuantity: number;
    code: string;
    endsAt?: Date | null;
};

export type RewardType = 'Shards';

export type SelectStarterRequest = {
    starterOption: StarterOption;
};

export type SetDebugModeRequest = {
    enabled: boolean;
};

export type SocialUrl = {
    url: string;
};

export type StarterOption = 'Digby' | 'Toru' | 'Ravolt';

export type StatusEffect = {
    expiresAt: Date;
    type: EffectType;
};

export type StatusEffects = {
    [key: string]: unknown;
};

export type TakeHitsComboDto = {
    hits: number;
};

export type TicketCountResponse = {
    count: number;
    maxCount: number;
};

export type UpdateDebugConfigSkipOnboardingRequest = {
    value: boolean;
};

export type UpdateStepRequest = {
    newStep: string;
};

export type UpdateWalletDto = {
    address: string;
    appName: string;
};

export type UseItemRequest = {
    itemId: string;
};

export type UserEggStats = {
    hatcheningPoints: number;
    goldenTreasureEggs: number;
    silverTreasureEggs: number;
    bronzeTreasureEggs: number;
};

export type WalletPlayer = {
    address: string;
    appName: string;
};

export type WildsSignedUrl = {
    wildsUrl: string;
};

export type GetApiBansGetBanStateResponse = PlayerBannedState;

export type PostApiBfSaveData = {
    requestBody?: Array<BfDto>;
};

export type PostApiBfSaveResponse = unknown;

export type PostApiClicksMiningAndFeedingData = {
    requestBody?: MiningAndFeedingRequest;
};

export type PostApiClicksMiningAndFeedingResponse = unknown;

export type GetApiCoinsShopGetListingsResponse = Array<CoinShopItemListing>;

export type PostApiCoinsShopBuyItemData = {
    requestBody?: BuyItemRequest;
};

export type PostApiCoinsShopBuyItemResponse = unknown;

export type GetApiCoinsShopGetCoinsShopGrainResponse = ICoinsShopGrain;

export type GetApiConnectSocialsGetConnectedSocialsResponse = ConnectedSocials;

export type GetApiConnectSocialsIsTwitterConnectedResponse = boolean;

export type GetApiConnectSocialsConnectTwitterResponse = SocialUrl;

export type GetApiConnectSocialsConnectTwitterCallbackData = {
    code: string;
    state: string;
};

export type GetApiConnectSocialsConnectTwitterCallbackResponse = unknown;

export type GetApiConnectSocialsConnectDiscordResponse = SocialUrl;

export type GetApiConnectSocialsConnectDiscordCallbackData = {
    code: string;
    state: string;
};

export type GetApiConnectSocialsConnectDiscordCallbackResponse = unknown;

export type GetApiConnectSocialsIsDiscordConnectedResponse = boolean;

export type GetApiConnectSocialsConnectZephyrusResponse = SocialUrl;

export type GetApiConnectSocialsConnectZephyrusCallbackData = {
    code: string;
    state: string;
};

export type GetApiConnectSocialsConnectZephyrusCallbackResponse = unknown;

export type GetApiDailyStreakGetStateResponse = DailyStreakState;

export type PostApiDailyStreakClaimDailyBonusResponse = unknown;

export type PostApiDailyStreakDebugResetStreakResponse = unknown;

export type PostApiDailyStreakSetDebugModeData = {
    requestBody?: SetDebugModeRequest;
};

export type PostApiDailyStreakSetDebugModeResponse = unknown;

export type GetApiDebugPingPingResponse = unknown;

export type GetApiDebugErrorErrorResponse = unknown;

export type GetApiDebugRussianRouletteRussianRouletteResponse = unknown;

export type GetApiDebugGetDebutValuesResponse = DebugValues;

export type GetApiDebugIsAutoFeedStartedResponse = boolean;

export type PostApiDebugStartAutoFeedResponse = unknown;

export type PostApiDebugStopAutoFeedResponse = unknown;

export type PostApiDebugDebugClearDataResponse = unknown;

export type PostApiDebugDebugDeleteShopPurchasesResponse = unknown;

export type PostApiDebugDebugFakePurchaseResponse = unknown;

export type PostApiDebugDebugFakePurchaseItemData = {
    requestBody?: DebugFakePurchaseItemRequest;
};

export type PostApiDebugDebugFakePurchaseItemResponse = unknown;

export type PostApiDebugDebugDestroyQuestsResponse = unknown;

export type PostApiDebugDebugCreateRefereeResponse = unknown;

export type PostApiDebugDebugDestroySocialConnectionsResponse = unknown;

export type PostApiDebugDebugResetCoinsResponse = unknown;

export type PostApiDebugDebugAddCoinsData = {
    requestBody?: DebugAddCoinsRequest;
};

export type PostApiDebugDebugAddCoinsResponse = unknown;

export type PostApiDebugDebugRechargeEnergyResponse = unknown;

export type PostApiDebugDebugAddShardsData = {
    requestBody?: DebugAddShardsRequest;
};

export type PostApiDebugDebugAddShardsResponse = unknown;

export type PostApiDebugUpdateDebugConfigSkipOnboardingData = {
    requestBody?: UpdateDebugConfigSkipOnboardingRequest;
};

export type PostApiDebugUpdateDebugConfigSkipOnboardingResponse = unknown;

export type GetApiDebugGetDebugConfigResponse = {
    [key: string]: unknown;
};

export type PostApiDebugSendDebugNotificationResponse = unknown;

export type GetApiEnergyBallsGetEnergyBallStateResponse = EnergyBall;

export type PostApiEnergyBallsTakeHitsComboByBallIdData = {
    ballId: string;
    requestBody?: TakeHitsComboDto;
};

export type PostApiEnergyBallsTakeHitsComboByBallIdResponse = unknown;

export type PostApiEnergyBallsDebugResetResponse = unknown;

export type PostApiEnergyBallsDebugTakeHitsByBallIdData = {
    ballId: string;
    requestBody?: TakeHitsComboDto;
};

export type PostApiEnergyBallsDebugTakeHitsByBallIdResponse = unknown;

export type PostApiGameUpdateCoinsSnapshotResponse = CoinsSnapshot;

export type GetApiGameCoinsEarnedAwayResponse = number;

export type GetApiGameGetPlayerStateResponse = PlayerStateDto;

export type GetApiInventoryGetInventoryResponse = Array<InventoryItem>;

export type PostApiInventoryEquipItemData = {
    requestBody?: EquipItemRequest;
};

export type PostApiInventoryEquipItemResponse = unknown;

export type PostApiInventoryUseItemData = {
    requestBody?: UseItemRequest;
};

export type PostApiInventoryUseItemResponse = unknown;

export type PostApiInventoryUnequipHatResponse = unknown;

export type GetResponse = string;

export type GetSocialSuccessData = {
    platform: string;
};

export type GetSocialSuccessResponse = unknown;

export type GetSocialErrorData = {
    httpCode: string;
    platform: string;
};

export type GetSocialErrorResponse = unknown;

export type GetHelloResponse = string;

export type GetApiOnboardingGetOnboardingStateResponse = OnboardingState;

export type PostApiOnboardingSelectStarterData = {
    requestBody?: SelectStarterRequest;
};

export type PostApiOnboardingSelectStarterResponse = unknown;

export type PostApiOnboardingUpdateStepData = {
    requestBody?: UpdateStepRequest;
};

export type PostApiOnboardingUpdateStepResponse = unknown;

export type PostApiOnboardingCompleteOnboardingResponse = unknown;

export type GetAdminApiPlayersData = {
    page?: number;
    pageSize?: number;
    searchText?: string;
};

export type GetAdminApiPlayersResponse = PlayerPaginatedResponse;

export type GetApiQuestsGetActiveQuestsResponse = Array<PlayerQuestDto>;

export type GetApiQuestsGetQuestByQuestIdData = {
    questId: string;
};

export type GetApiQuestsGetQuestByQuestIdResponse = PlayerQuestDto;

export type PostApiQuestsVerifyQuestByQuestIdData = {
    questId: string;
};

export type PostApiQuestsVerifyQuestByQuestIdResponse = QuestVerificationResult;

export type PostApiQuestsMoveQuestToVerifiableByQuestIdData = {
    questId: string;
};

export type PostApiQuestsMoveQuestToVerifiableByQuestIdResponse = unknown;

export type GetAdminApiQuestsResponse = Array<Quest>;

export type PostAdminApiQuestsData = {
    requestBody?: CreateQuestDto;
};

export type PostAdminApiQuestsResponse = Quest;

export type GetAdminApiQuestsByIdData = {
    id: string;
};

export type GetAdminApiQuestsByIdResponse = Quest;

export type PutAdminApiQuestsByIdData = {
    id: string;
    requestBody?: Quest;
};

export type PutAdminApiQuestsByIdResponse = unknown;

export type DeleteAdminApiQuestsByIdData = {
    id: string;
};

export type DeleteAdminApiQuestsByIdResponse = unknown;

export type GetApiRaffleTicketsGetRaffleTicketsResponse = GetRaffleTicketsResponse;

export type GetApiRaffleTicketsGetTicketsSinceFirstSnapshotResponse = GetRaffleTicketsResponse;

export type PostApiRaffleTicketsUseRaffleTicketResponse = RaffleReward;

export type GetApiReferralsGerReferralCodeResponse = ReferralCodeResponse;

export type GetApiReferralsGetReferralsStateResponse = ReferralsManagerState;

export type GetApiReferralsGetRefereesData = {
    page?: number;
    pageSize?: number;
};

export type GetApiReferralsGetRefereesResponse = Array<RefereeDto>;

export type GetApiReferralsGetRefereesCountResponse = number;

export type PostApiReincarnateReincarnateResponse = unknown;

export type GetAdminApiRewardCodesResponse = Array<RewardCode>;

export type PostAdminApiRewardCodesData = {
    requestBody?: CreateRewardCodeDto;
};

export type PostAdminApiRewardCodesResponse = RewardCode;

export type GetAdminApiRewardCodesByIdData = {
    id: string;
};

export type GetAdminApiRewardCodesByIdResponse = RewardCode;

export type PutAdminApiRewardCodesByIdData = {
    id: string;
    requestBody?: RewardCode;
};

export type PutAdminApiRewardCodesByIdResponse = unknown;

export type DeleteAdminApiRewardCodesByIdData = {
    id: string;
};

export type DeleteAdminApiRewardCodesByIdResponse = unknown;

export type GetApiShopInitiatePurchaseByListingIdData = {
    listingId: string;
    quantity?: number;
};

export type GetApiShopInitiatePurchaseByListingIdResponse = InitiatePurchaseResponse;

export type GetApiShopGetShopListingsResponse = Array<PlayerShopListing>;

export type GetApiShopGetBoosterShopListingsResponse = Array<PlayerShopListing>;

export type GetApiSpecialSignupTicketsGetTicketCountResponse = TicketCountResponse;

export type PostApiUpgradesBuyUpgradeData = {
    requestBody?: BuyUpgradeParams;
};

export type PostApiUpgradesBuyUpgradeResponse = PurchasableUpgrade;

export type GetApiUpgradesGetPurchasableUpgradesResponse = Array<PurchasableUpgrade>;

export type PostApiWalletsUpdateWalletData = {
    requestBody?: UpdateWalletDto;
};

export type PostApiWalletsUpdateWalletResponse = unknown;

export type GetApiWildsCommunicationGetWildsSignedUrlResponse = WildsSignedUrl;

export type GetApiWildsCommunicationGetUserEggStatsResponse = UserEggStats;

export type $OpenApiTs = {
    '/api/Bans/GetBanState': {
        get: {
            res: {
                /**
                 * OK
                 */
                200: PlayerBannedState;
            };
        };
    };
    '/api/Bf/Save': {
        post: {
            req: PostApiBfSaveData;
            res: {
                /**
                 * OK
                 */
                200: unknown;
            };
        };
    };
    '/api/Clicks/MiningAndFeeding': {
        post: {
            req: PostApiClicksMiningAndFeedingData;
            res: {
                /**
                 * OK
                 */
                200: unknown;
            };
        };
    };
    '/api/CoinsShop/GetListings': {
        get: {
            res: {
                /**
                 * OK
                 */
                200: Array<CoinShopItemListing>;
            };
        };
    };
    '/api/CoinsShop/BuyItem': {
        post: {
            req: PostApiCoinsShopBuyItemData;
            res: {
                /**
                 * OK
                 */
                200: unknown;
            };
        };
    };
    '/api/CoinsShop/GetCoinsShopGrain': {
        get: {
            res: {
                /**
                 * OK
                 */
                200: ICoinsShopGrain;
            };
        };
    };
    '/api/ConnectSocials/GetConnectedSocials': {
        get: {
            res: {
                /**
                 * OK
                 */
                200: ConnectedSocials;
            };
        };
    };
    '/api/ConnectSocials/IsTwitterConnected': {
        get: {
            res: {
                /**
                 * OK
                 */
                200: boolean;
            };
        };
    };
    '/api/ConnectSocials/ConnectTwitter': {
        get: {
            res: {
                /**
                 * OK
                 */
                200: SocialUrl;
            };
        };
    };
    '/api/ConnectSocials/ConnectTwitterCallback': {
        get: {
            req: GetApiConnectSocialsConnectTwitterCallbackData;
            res: {
                /**
                 * OK
                 */
                200: unknown;
            };
        };
    };
    '/api/ConnectSocials/ConnectDiscord': {
        get: {
            res: {
                /**
                 * OK
                 */
                200: SocialUrl;
            };
        };
    };
    '/api/ConnectSocials/ConnectDiscordCallback': {
        get: {
            req: GetApiConnectSocialsConnectDiscordCallbackData;
            res: {
                /**
                 * OK
                 */
                200: unknown;
            };
        };
    };
    '/api/ConnectSocials/IsDiscordConnected': {
        get: {
            res: {
                /**
                 * OK
                 */
                200: boolean;
            };
        };
    };
    '/api/ConnectSocials/ConnectZephyrus': {
        get: {
            res: {
                /**
                 * OK
                 */
                200: SocialUrl;
            };
        };
    };
    '/api/ConnectSocials/ConnectZephyrusCallback': {
        get: {
            req: GetApiConnectSocialsConnectZephyrusCallbackData;
            res: {
                /**
                 * OK
                 */
                200: unknown;
            };
        };
    };
    '/api/DailyStreak/GetState': {
        get: {
            res: {
                /**
                 * OK
                 */
                200: DailyStreakState;
            };
        };
    };
    '/api/DailyStreak/ClaimDailyBonus': {
        post: {
            res: {
                /**
                 * OK
                 */
                200: unknown;
            };
        };
    };
    '/api/DailyStreak/DebugResetStreak': {
        post: {
            res: {
                /**
                 * OK
                 */
                200: unknown;
            };
        };
    };
    '/api/DailyStreak/SetDebugMode': {
        post: {
            req: PostApiDailyStreakSetDebugModeData;
            res: {
                /**
                 * OK
                 */
                200: unknown;
            };
        };
    };
    '/api/Debug/Ping/ping': {
        get: {
            res: {
                /**
                 * OK
                 */
                200: unknown;
            };
        };
    };
    '/api/Debug/Error/error': {
        get: {
            res: {
                /**
                 * OK
                 */
                200: unknown;
            };
        };
    };
    '/api/Debug/RussianRoulette/russian-roulette': {
        get: {
            res: {
                /**
                 * OK
                 */
                200: unknown;
            };
        };
    };
    '/api/Debug/GetDebutValues': {
        get: {
            res: {
                /**
                 * OK
                 */
                200: DebugValues;
            };
        };
    };
    '/api/Debug/IsAutoFeedStarted': {
        get: {
            res: {
                /**
                 * OK
                 */
                200: boolean;
            };
        };
    };
    '/api/Debug/StartAutoFeed': {
        post: {
            res: {
                /**
                 * OK
                 */
                200: unknown;
            };
        };
    };
    '/api/Debug/StopAutoFeed': {
        post: {
            res: {
                /**
                 * OK
                 */
                200: unknown;
            };
        };
    };
    '/api/Debug/DebugClearData': {
        post: {
            res: {
                /**
                 * OK
                 */
                200: unknown;
            };
        };
    };
    '/api/Debug/DebugDeleteShopPurchases': {
        post: {
            res: {
                /**
                 * OK
                 */
                200: unknown;
            };
        };
    };
    '/api/Debug/DebugFakePurchase': {
        post: {
            res: {
                /**
                 * OK
                 */
                200: unknown;
            };
        };
    };
    '/api/Debug/DebugFakePurchaseItem': {
        post: {
            req: PostApiDebugDebugFakePurchaseItemData;
            res: {
                /**
                 * OK
                 */
                200: unknown;
            };
        };
    };
    '/api/Debug/DebugDestroyQuests': {
        post: {
            res: {
                /**
                 * OK
                 */
                200: unknown;
            };
        };
    };
    '/api/Debug/DebugCreateReferee': {
        post: {
            res: {
                /**
                 * OK
                 */
                200: unknown;
            };
        };
    };
    '/api/Debug/DebugDestroySocialConnections': {
        post: {
            res: {
                /**
                 * OK
                 */
                200: unknown;
            };
        };
    };
    '/api/Debug/DebugResetCoins': {
        post: {
            res: {
                /**
                 * OK
                 */
                200: unknown;
            };
        };
    };
    '/api/Debug/DebugAddCoins': {
        post: {
            req: PostApiDebugDebugAddCoinsData;
            res: {
                /**
                 * OK
                 */
                200: unknown;
            };
        };
    };
    '/api/Debug/DebugRechargeEnergy': {
        post: {
            res: {
                /**
                 * OK
                 */
                200: unknown;
            };
        };
    };
    '/api/Debug/DebugAddShards': {
        post: {
            req: PostApiDebugDebugAddShardsData;
            res: {
                /**
                 * OK
                 */
                200: unknown;
            };
        };
    };
    '/api/Debug/UpdateDebugConfigSkipOnboarding': {
        post: {
            req: PostApiDebugUpdateDebugConfigSkipOnboardingData;
            res: {
                /**
                 * OK
                 */
                200: unknown;
            };
        };
    };
    '/api/Debug/GetDebugConfig': {
        get: {
            res: {
                /**
                 * OK
                 */
                200: {
                    [key: string]: unknown;
                };
            };
        };
    };
    '/api/Debug/SendDebugNotification': {
        post: {
            res: {
                /**
                 * OK
                 */
                200: unknown;
            };
        };
    };
    '/api/EnergyBalls/GetEnergyBallState': {
        get: {
            res: {
                /**
                 * OK
                 */
                200: EnergyBall;
            };
        };
    };
    '/api/EnergyBalls/TakeHitsCombo/{ballId}': {
        post: {
            req: PostApiEnergyBallsTakeHitsComboByBallIdData;
            res: {
                /**
                 * OK
                 */
                200: unknown;
            };
        };
    };
    '/api/EnergyBalls/DebugReset': {
        post: {
            res: {
                /**
                 * OK
                 */
                200: unknown;
            };
        };
    };
    '/api/EnergyBalls/DebugTakeHits/{ballId}': {
        post: {
            req: PostApiEnergyBallsDebugTakeHitsByBallIdData;
            res: {
                /**
                 * OK
                 */
                200: unknown;
            };
        };
    };
    '/api/Game/UpdateCoinsSnapshot': {
        post: {
            res: {
                /**
                 * OK
                 */
                200: CoinsSnapshot;
            };
        };
    };
    '/api/Game/CoinsEarnedAway': {
        get: {
            res: {
                /**
                 * OK
                 */
                200: number;
            };
        };
    };
    '/api/Game/GetPlayerState': {
        get: {
            res: {
                /**
                 * OK
                 */
                200: PlayerStateDto;
            };
        };
    };
    '/api/Inventory/GetInventory': {
        get: {
            res: {
                /**
                 * OK
                 */
                200: Array<InventoryItem>;
            };
        };
    };
    '/api/Inventory/EquipItem': {
        post: {
            req: PostApiInventoryEquipItemData;
            res: {
                /**
                 * OK
                 */
                200: unknown;
            };
        };
    };
    '/api/Inventory/UseItem': {
        post: {
            req: PostApiInventoryUseItemData;
            res: {
                /**
                 * OK
                 */
                200: unknown;
            };
        };
    };
    '/api/Inventory/UnequipHat': {
        post: {
            res: {
                /**
                 * OK
                 */
                200: unknown;
            };
        };
    };
    '/': {
        get: {
            res: {
                /**
                 * OK
                 */
                200: string;
            };
        };
    };
    '/social-success': {
        get: {
            req: GetSocialSuccessData;
            res: {
                /**
                 * OK
                 */
                200: unknown;
            };
        };
    };
    '/social-error': {
        get: {
            req: GetSocialErrorData;
            res: {
                /**
                 * OK
                 */
                200: unknown;
            };
        };
    };
    '/hello': {
        get: {
            res: {
                /**
                 * OK
                 */
                200: string;
            };
        };
    };
    '/api/Onboarding/GetOnboardingState': {
        get: {
            res: {
                /**
                 * OK
                 */
                200: OnboardingState;
            };
        };
    };
    '/api/Onboarding/SelectStarter': {
        post: {
            req: PostApiOnboardingSelectStarterData;
            res: {
                /**
                 * OK
                 */
                200: unknown;
            };
        };
    };
    '/api/Onboarding/UpdateStep': {
        post: {
            req: PostApiOnboardingUpdateStepData;
            res: {
                /**
                 * OK
                 */
                200: unknown;
            };
        };
    };
    '/api/Onboarding/CompleteOnboarding': {
        post: {
            res: {
                /**
                 * OK
                 */
                200: unknown;
            };
        };
    };
    '/admin/api/Players': {
        get: {
            req: GetAdminApiPlayersData;
            res: {
                /**
                 * OK
                 */
                200: PlayerPaginatedResponse;
            };
        };
    };
    '/api/Quests/GetActiveQuests': {
        get: {
            res: {
                /**
                 * OK
                 */
                200: Array<PlayerQuestDto>;
            };
        };
    };
    '/api/Quests/GetQuest/{questId}': {
        get: {
            req: GetApiQuestsGetQuestByQuestIdData;
            res: {
                /**
                 * OK
                 */
                200: PlayerQuestDto;
            };
        };
    };
    '/api/Quests/VerifyQuest/{questId}': {
        post: {
            req: PostApiQuestsVerifyQuestByQuestIdData;
            res: {
                /**
                 * OK
                 */
                200: QuestVerificationResult;
            };
        };
    };
    '/api/Quests/MoveQuestToVerifiable/{questId}': {
        post: {
            req: PostApiQuestsMoveQuestToVerifiableByQuestIdData;
            res: {
                /**
                 * OK
                 */
                200: unknown;
            };
        };
    };
    '/admin/api/Quests': {
        get: {
            res: {
                /**
                 * OK
                 */
                200: Array<Quest>;
            };
        };
        post: {
            req: PostAdminApiQuestsData;
            res: {
                /**
                 * OK
                 */
                200: Quest;
            };
        };
    };
    '/admin/api/Quests/{id}': {
        get: {
            req: GetAdminApiQuestsByIdData;
            res: {
                /**
                 * OK
                 */
                200: Quest;
            };
        };
        put: {
            req: PutAdminApiQuestsByIdData;
            res: {
                /**
                 * OK
                 */
                200: unknown;
            };
        };
        delete: {
            req: DeleteAdminApiQuestsByIdData;
            res: {
                /**
                 * OK
                 */
                200: unknown;
            };
        };
    };
    '/api/RaffleTickets/GetRaffleTickets': {
        get: {
            res: {
                /**
                 * OK
                 */
                200: GetRaffleTicketsResponse;
            };
        };
    };
    '/api/RaffleTickets/GetTicketsSinceFirstSnapshot': {
        get: {
            res: {
                /**
                 * OK
                 */
                200: GetRaffleTicketsResponse;
            };
        };
    };
    '/api/RaffleTickets/UseRaffleTicket': {
        post: {
            res: {
                /**
                 * OK
                 */
                200: RaffleReward;
            };
        };
    };
    '/api/Referrals/GerReferralCode': {
        get: {
            res: {
                /**
                 * OK
                 */
                200: ReferralCodeResponse;
            };
        };
    };
    '/api/Referrals/GetReferralsState': {
        get: {
            res: {
                /**
                 * OK
                 */
                200: ReferralsManagerState;
            };
        };
    };
    '/api/Referrals/GetReferees': {
        get: {
            req: GetApiReferralsGetRefereesData;
            res: {
                /**
                 * OK
                 */
                200: Array<RefereeDto>;
            };
        };
    };
    '/api/Referrals/GetRefereesCount': {
        get: {
            res: {
                /**
                 * OK
                 */
                200: number;
            };
        };
    };
    '/api/Reincarnate/Reincarnate': {
        post: {
            res: {
                /**
                 * OK
                 */
                200: unknown;
            };
        };
    };
    '/admin/api/RewardCodes': {
        get: {
            res: {
                /**
                 * OK
                 */
                200: Array<RewardCode>;
            };
        };
        post: {
            req: PostAdminApiRewardCodesData;
            res: {
                /**
                 * OK
                 */
                200: RewardCode;
            };
        };
    };
    '/admin/api/RewardCodes/{id}': {
        get: {
            req: GetAdminApiRewardCodesByIdData;
            res: {
                /**
                 * OK
                 */
                200: RewardCode;
            };
        };
        put: {
            req: PutAdminApiRewardCodesByIdData;
            res: {
                /**
                 * OK
                 */
                200: unknown;
            };
        };
        delete: {
            req: DeleteAdminApiRewardCodesByIdData;
            res: {
                /**
                 * OK
                 */
                200: unknown;
            };
        };
    };
    '/api/Shop/InitiatePurchase/{listingId}': {
        get: {
            req: GetApiShopInitiatePurchaseByListingIdData;
            res: {
                /**
                 * OK
                 */
                200: InitiatePurchaseResponse;
            };
        };
    };
    '/api/Shop/GetShopListings': {
        get: {
            res: {
                /**
                 * OK
                 */
                200: Array<PlayerShopListing>;
            };
        };
    };
    '/api/Shop/GetBoosterShopListings': {
        get: {
            res: {
                /**
                 * OK
                 */
                200: Array<PlayerShopListing>;
            };
        };
    };
    '/api/SpecialSignupTickets/GetTicketCount': {
        get: {
            res: {
                /**
                 * OK
                 */
                200: TicketCountResponse;
            };
        };
    };
    '/api/Upgrades/BuyUpgrade': {
        post: {
            req: PostApiUpgradesBuyUpgradeData;
            res: {
                /**
                 * OK
                 */
                200: PurchasableUpgrade;
            };
        };
    };
    '/api/Upgrades/GetPurchasableUpgrades': {
        get: {
            res: {
                /**
                 * OK
                 */
                200: Array<PurchasableUpgrade>;
            };
        };
    };
    '/api/Wallets/UpdateWallet': {
        post: {
            req: PostApiWalletsUpdateWalletData;
            res: {
                /**
                 * OK
                 */
                200: unknown;
            };
        };
    };
    '/api/WildsCommunication/GetWildsSignedUrl': {
        get: {
            res: {
                /**
                 * OK
                 */
                200: WildsSignedUrl;
            };
        };
    };
    '/api/WildsCommunication/GetUserEggStats': {
        get: {
            res: {
                /**
                 * OK
                 */
                200: UserEggStats;
            };
        };
    };
};

export type GetApiBansGetBanStateResponseTransformer = (data: any) => Promise<GetApiBansGetBanStateResponse>;

export type PlayerBannedStateModelResponseTransformer = (data: any) => PlayerBannedState;

export const PlayerBannedStateModelResponseTransformer: PlayerBannedStateModelResponseTransformer = data => {
    if (data?.bannedAt) {
        data.bannedAt = new Date(data.bannedAt);
    }
    return data;
};

export const GetApiBansGetBanStateResponseTransformer: GetApiBansGetBanStateResponseTransformer = async (data) => {
    PlayerBannedStateModelResponseTransformer(data);
    return data;
};

export type GetApiDailyStreakGetStateResponseTransformer = (data: any) => Promise<GetApiDailyStreakGetStateResponse>;

export type DailyStreakStateModelResponseTransformer = (data: any) => DailyStreakState;

export const DailyStreakStateModelResponseTransformer: DailyStreakStateModelResponseTransformer = data => {
    if (data?.lastClaimDate) {
        data.lastClaimDate = new Date(data.lastClaimDate);
    }
    return data;
};

export const GetApiDailyStreakGetStateResponseTransformer: GetApiDailyStreakGetStateResponseTransformer = async (data) => {
    DailyStreakStateModelResponseTransformer(data);
    return data;
};

export type GetApiDebugGetDebutValuesResponseTransformer = (data: any) => Promise<GetApiDebugGetDebutValuesResponse>;

export type DebugValuesModelResponseTransformer = (data: any) => DebugValues;

export type PlayerDebugValuesModelResponseTransformer = (data: any) => PlayerDebugValues;

export type CoinsDebugValuesModelResponseTransformer = (data: any) => CoinsDebugValues;

export type CoinsSnapshotModelResponseTransformer = (data: any) => CoinsSnapshot;

export const CoinsSnapshotModelResponseTransformer: CoinsSnapshotModelResponseTransformer = data => {
    if (data?.updatedAt) {
        data.updatedAt = new Date(data.updatedAt);
    }
    return data;
};

export const CoinsDebugValuesModelResponseTransformer: CoinsDebugValuesModelResponseTransformer = data => {
    if (data?.snapshot) {
        CoinsSnapshotModelResponseTransformer(data.snapshot);
    }
    if (data?.earnStopsAt) {
        data.earnStopsAt = new Date(data.earnStopsAt);
    }
    return data;
};

export const PlayerDebugValuesModelResponseTransformer: PlayerDebugValuesModelResponseTransformer = data => {
    if (data?.coins) {
        CoinsDebugValuesModelResponseTransformer(data.coins);
    }
    return data;
};

export const DebugValuesModelResponseTransformer: DebugValuesModelResponseTransformer = data => {
    if (data?.playerDebugValues) {
        PlayerDebugValuesModelResponseTransformer(data.playerDebugValues);
    }
    return data;
};

export const GetApiDebugGetDebutValuesResponseTransformer: GetApiDebugGetDebutValuesResponseTransformer = async (data) => {
    DebugValuesModelResponseTransformer(data);
    return data;
};

export type PostApiGameUpdateCoinsSnapshotResponseTransformer = (data: any) => Promise<PostApiGameUpdateCoinsSnapshotResponse>;

export const PostApiGameUpdateCoinsSnapshotResponseTransformer: PostApiGameUpdateCoinsSnapshotResponseTransformer = async (data) => {
    CoinsSnapshotModelResponseTransformer(data);
    return data;
};

export type GetApiGameGetPlayerStateResponseTransformer = (data: any) => Promise<GetApiGameGetPlayerStateResponse>;

export type PlayerStateDtoModelResponseTransformer = (data: any) => PlayerStateDto;

export type EnergySnapshotModelResponseTransformer = (data: any) => EnergySnapshot;

export const EnergySnapshotModelResponseTransformer: EnergySnapshotModelResponseTransformer = data => {
    if (data?.updatedAt) {
        data.updatedAt = new Date(data.updatedAt);
    }
    return data;
};

export type BeastDtoModelResponseTransformer = (data: any) => BeastDto;

export type HappinessSnapshotModelResponseTransformer = (data: any) => HappinessSnapshot;

export const HappinessSnapshotModelResponseTransformer: HappinessSnapshotModelResponseTransformer = data => {
    if (data?.updatedAt) {
        data.updatedAt = new Date(data.updatedAt);
    }
    return data;
};

export const BeastDtoModelResponseTransformer: BeastDtoModelResponseTransformer = data => {
    if (data?.happinessSnapshot) {
        HappinessSnapshotModelResponseTransformer(data.happinessSnapshot);
    }
    return data;
};

export type StatusEffectModelResponseTransformer = (data: any) => StatusEffect;

export const StatusEffectModelResponseTransformer: StatusEffectModelResponseTransformer = data => {
    if (data?.expiresAt) {
        data.expiresAt = new Date(data.expiresAt);
    }
    return data;
};

export const PlayerStateDtoModelResponseTransformer: PlayerStateDtoModelResponseTransformer = data => {
    if (data?.energySnapshot) {
        EnergySnapshotModelResponseTransformer(data.energySnapshot);
    }
    if (data?.coinsSnapshot) {
        CoinsSnapshotModelResponseTransformer(data.coinsSnapshot);
    }
    if (data?.coinsEarningEndsAt) {
        data.coinsEarningEndsAt = new Date(data.coinsEarningEndsAt);
    }
    if (data?.beast) {
        BeastDtoModelResponseTransformer(data.beast);
    }
    if (data?.createdAt) {
        data.createdAt = new Date(data.createdAt);
    }
    if (Array.isArray(data?.statusEffects)) {
        data.statusEffects.forEach(StatusEffectModelResponseTransformer);
    }
    return data;
};

export const GetApiGameGetPlayerStateResponseTransformer: GetApiGameGetPlayerStateResponseTransformer = async (data) => {
    PlayerStateDtoModelResponseTransformer(data);
    return data;
};

export type GetAdminApiPlayersResponseTransformer = (data: any) => Promise<GetAdminApiPlayersResponse>;

export type PlayerPaginatedResponseModelResponseTransformer = (data: any) => PlayerPaginatedResponse;

export type PlayerModelResponseTransformer = (data: any) => Player;

export type BeastModelResponseTransformer = (data: any) => Beast;

export const BeastModelResponseTransformer: BeastModelResponseTransformer = data => {
    if (data?.happinessSnapshot) {
        HappinessSnapshotModelResponseTransformer(data.happinessSnapshot);
    }
    return data;
};

export const PlayerModelResponseTransformer: PlayerModelResponseTransformer = data => {
    if (data?.energySnapshot) {
        EnergySnapshotModelResponseTransformer(data.energySnapshot);
    }
    if (data?.coinsSnapshot) {
        CoinsSnapshotModelResponseTransformer(data.coinsSnapshot);
    }
    if (Array.isArray(data?.beasts)) {
        data.beasts.forEach(BeastModelResponseTransformer);
    }
    if (data?.createdAt) {
        data.createdAt = new Date(data.createdAt);
    }
    if (data?.beast) {
        BeastModelResponseTransformer(data.beast);
    }
    return data;
};

export const PlayerPaginatedResponseModelResponseTransformer: PlayerPaginatedResponseModelResponseTransformer = data => {
    if (Array.isArray(data?.items)) {
        data.items.forEach(PlayerModelResponseTransformer);
    }
    return data;
};

export const GetAdminApiPlayersResponseTransformer: GetAdminApiPlayersResponseTransformer = async (data) => {
    PlayerPaginatedResponseModelResponseTransformer(data);
    return data;
};

export type GetApiQuestsGetActiveQuestsResponseTransformer = (data: any) => Promise<GetApiQuestsGetActiveQuestsResponse>;

export type PlayerQuestDtoModelResponseTransformer = (data: any) => PlayerQuestDto;

export type QuestModelResponseTransformer = (data: any) => Quest;

export const QuestModelResponseTransformer: QuestModelResponseTransformer = data => {
    if (data?.startsAt) {
        data.startsAt = new Date(data.startsAt);
    }
    if (data?.endsAt) {
        data.endsAt = new Date(data.endsAt);
    }
    if (data?.createdAt) {
        data.createdAt = new Date(data.createdAt);
    }
    return data;
};

export const PlayerQuestDtoModelResponseTransformer: PlayerQuestDtoModelResponseTransformer = data => {
    if (data?.quest) {
        QuestModelResponseTransformer(data.quest);
    }
    return data;
};

export const GetApiQuestsGetActiveQuestsResponseTransformer: GetApiQuestsGetActiveQuestsResponseTransformer = async (data) => {
    if (Array.isArray(data)) {
        data.forEach(PlayerQuestDtoModelResponseTransformer);
    }
    return data;
};

export type GetApiQuestsGetQuestByQuestIdResponseTransformer = (data: any) => Promise<GetApiQuestsGetQuestByQuestIdResponse>;

export const GetApiQuestsGetQuestByQuestIdResponseTransformer: GetApiQuestsGetQuestByQuestIdResponseTransformer = async (data) => {
    PlayerQuestDtoModelResponseTransformer(data);
    return data;
};

export type GetAdminApiQuestsResponseTransformer = (data: any) => Promise<GetAdminApiQuestsResponse>;

export const GetAdminApiQuestsResponseTransformer: GetAdminApiQuestsResponseTransformer = async (data) => {
    if (Array.isArray(data)) {
        data.forEach(QuestModelResponseTransformer);
    }
    return data;
};

export type PostAdminApiQuestsResponseTransformer = (data: any) => Promise<PostAdminApiQuestsResponse>;

export const PostAdminApiQuestsResponseTransformer: PostAdminApiQuestsResponseTransformer = async (data) => {
    QuestModelResponseTransformer(data);
    return data;
};

export type GetAdminApiQuestsByIdResponseTransformer = (data: any) => Promise<GetAdminApiQuestsByIdResponse>;

export const GetAdminApiQuestsByIdResponseTransformer: GetAdminApiQuestsByIdResponseTransformer = async (data) => {
    QuestModelResponseTransformer(data);
    return data;
};

export type GetAdminApiRewardCodesResponseTransformer = (data: any) => Promise<GetAdminApiRewardCodesResponse>;

export type RewardCodeModelResponseTransformer = (data: any) => RewardCode;

export const RewardCodeModelResponseTransformer: RewardCodeModelResponseTransformer = data => {
    if (data?.endsAt) {
        data.endsAt = new Date(data.endsAt);
    }
    return data;
};

export const GetAdminApiRewardCodesResponseTransformer: GetAdminApiRewardCodesResponseTransformer = async (data) => {
    if (Array.isArray(data)) {
        data.forEach(RewardCodeModelResponseTransformer);
    }
    return data;
};

export type PostAdminApiRewardCodesResponseTransformer = (data: any) => Promise<PostAdminApiRewardCodesResponse>;

export const PostAdminApiRewardCodesResponseTransformer: PostAdminApiRewardCodesResponseTransformer = async (data) => {
    RewardCodeModelResponseTransformer(data);
    return data;
};

export type GetAdminApiRewardCodesByIdResponseTransformer = (data: any) => Promise<GetAdminApiRewardCodesByIdResponse>;

export const GetAdminApiRewardCodesByIdResponseTransformer: GetAdminApiRewardCodesByIdResponseTransformer = async (data) => {
    RewardCodeModelResponseTransformer(data);
    return data;
};